import React from 'react';
import { LinearGradient } from 'expo-linear-gradient';
const Gradient = (props) => {
    return React.createElement(LinearGradient, { ...props });
};
export { Gradient };
